import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/transportation.vue
var o = {
	name: "DtIconTransportation",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--transportation"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Transportation",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M3 2a.5.5 0 0 0-.5.5V5h3V2H3Zm0-1a1.5 1.5 0 0 0-1.5 1.5v6A1.5 1.5 0 0 0 3 10h.066l-.482.723a.5.5 0 0 0 .832.555L4.268 10h3.465l.851 1.277a.5.5 0 1 0 .832-.555L8.934 10H9a1.5 1.5 0 0 0 1.5-1.5v-6A1.5 1.5 0 0 0 9 1H3Zm3.5 1v3h3V2.5A.5.5 0 0 0 9 2H6.5Zm3 4h-7v2.5A.5.5 0 0 0 3 9h6a.5.5 0 0 0 .5-.5V6Zm-6 1.5A.5.5 0 0 1 4 7h.005a.5.5 0 1 1 0 1H4a.5.5 0 0 1-.5-.5Zm4 0A.5.5 0 0 1 8 7h.005a.5.5 0 1 1 0 1H8a.5.5 0 0 1-.5-.5Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=transportation.js.map